const DEFAULT_LOCATION_LABELS = {
  rack: 'Стеллаж',
  shelf: 'Полка',
  row: 'Ряд',
};

export function formatLocationDisplay(loc, labelMap = {}) {
  if (!loc || typeof loc !== 'object') return '—';
  if (loc.description) return loc.description;

  const keysOrder = Object.keys(labelMap).length
    ? Object.keys(labelMap)
    : Object.keys(loc).filter((k) => k !== 'description');

  const parts = [];
  keysOrder.forEach((k) => {
    const v = loc[k];
    if (v === undefined || v === null || v === '') return;
    const label = labelMap[k] || DEFAULT_LOCATION_LABELS[k] || k;
    parts.push(`${label}: ${v}`);
  });

  if (!parts.length && Object.keys(loc).length) {
    Object.entries(loc).forEach(([k, v]) => {
      if (k === 'description' || v === undefined || v === null || v === '') return;
      const label = labelMap[k] || DEFAULT_LOCATION_LABELS[k] || k;
      parts.push(`${label}: ${v}`);
    });
  }

  return parts.length ? parts.join(', ') : '—';
}

export const MATERIAL_UNITS = ['шт.', 'м.', 'кг.', 'л.', 'уп.'];

export function materialDisplayUnit(record) {
  if (!record) return '';
  return record.material_unit || record.unit || record.category_unit || '';
}

export function formatQuantityWithUnit(qty, unit) {
  if (qty === undefined || qty === null || qty === '') return '—';
  const s = typeof qty === 'number' ? String(qty) : String(qty);
  return unit ? `${s} ${unit}` : s;
}

export function formatQuantityPlain(qty) {
  if (qty === undefined || qty === null || qty === '') return '—';
  return typeof qty === 'number' ? String(qty) : String(qty);
}

export function formatMaterialIntegerDisplay(qty) {
  if (qty === undefined || qty === null || qty === '') return '—';
  const n = Number(qty);
  if (!Number.isFinite(n)) return String(qty);
  return String(Math.trunc(n));
}

export function normalizeApproved(value) {
  if (value === 0 || value === '0') return 'pending';
  if (value === 1 || value === '1') return 'approved';
  if (value === 2 || value === '2') return 'rejected';
  return value;
}

export function parseMaterialIntegerQty(value) {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') {
    if (!Number.isFinite(value) || value < 1) return null;
    if (!Number.isInteger(value)) return null;
    return value;
  }
  const s = String(value).trim();
  if (/[.,]/.test(s)) return null;
  if (!/^\d+$/.test(s)) return null;
  const n = parseInt(s, 10);
  if (!Number.isFinite(n) || n < 1) return null;
  return n;
}

export function isQuantityExplicitZero(value) {
  if (value === null || value === undefined || value === '') return false;
  return Number(value) === 0;
}

export function availableQtyFloor(recordOrNumber) {
  const q = typeof recordOrNumber === 'number'
    ? recordOrNumber
    : recordOrNumber?.quantity;
  if (q === undefined || q === null || q === '') return 0;
  return Math.floor(Number(q));
}

const DEFAULT_PLACEMENT_SCHEMA = [
  { key: 'rack', label: 'Стеллаж' },
  { key: 'shelf', label: 'Полка' },
];

/** Поля размещения по складу (temp_storage) — для накладной и форм материала */
export function placementSchemaForWarehouse(warehouse) {
  const ts = warehouse?.temp_storage;
  if (!ts || typeof ts !== 'object' || Object.keys(ts).length === 0) {
    return DEFAULT_PLACEMENT_SCHEMA;
  }
  return Object.entries(ts).map(([key, label]) => ({
    key,
    label: String(label),
  }));
}

/** Объект location для API из состояния { [key]: number } и схемы полей */
export function buildLocationPayloadFromState(placementState, schema) {
  const loc = {};
  schema.forEach(({ key }) => {
    const v = placementState[key];
    if (v !== undefined && v !== null && v !== '') {
      const n = Number(v);
      if (!Number.isNaN(n)) loc[key] = n;
    }
  });
  return Object.keys(loc).length ? loc : {};
}
